import { render, staticRenderFns } from "./DocumentVerifications.vue?vue&type=template&id=787b79cf&scoped=true&"
import script from "./DocumentVerifications.vue?vue&type=script&lang=js&"
export * from "./DocumentVerifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b79cf",
  null
  
)

export default component.exports